import { lazy } from 'react';

const MenuOrder = lazy(() => import('../../views/MenuOrder/index'));

const MenuOrderRoutes = [
    {
        path: '/settings/menu-order',
        element: <MenuOrder />
    }
];

export default MenuOrderRoutes;
